import React, { useState, useEffect } from 'react';
import { Modal, Button, Table } from 'antd';
import { getAllWorkOrderOpen } from '../../../Services/LocomotiveServices';
import moment from 'moment';
import { Link } from 'react-router-dom';

const MyComponent = ({ fetchFunction, showModal, handleOk, handleCancel, visible, stateData }) => {
    const [tableData, setTableData] = useState([]);
    const id = stateData?.data?.id

    const contractormap = (data) => {
        if (data) {
            let {
                firstName,
                lastName,
                Company
            } = data;

            let output = '';

            if (Company)
                output = Company;

            if (Company && firstName && lastName)
                output = output + "-"

            if (firstName && lastName)
                output = `${output} ${firstName} ${lastName}.`

            return output;
        }

        return ''

    };
    const fetchData = async () => {
        try {
            const data = await getAllWorkOrderOpen(id);
            setTableData(data?.data?.rows);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const columns = [
        {
            title: 'WO ID',
            dataIndex: 'woid',
            key: 'woid',
            width: '80px',
            render: (text, record) => (
                <Link to={{ pathname: '/Locomotive-work-order-edit', state: { id: record?.id } }}>{record?.id}</Link>
            ),
        },
        {
            title: 'REPAIRS NEEDED',
            dataIndex: 'repairsneeded',
            key: 'age',
            render: (text, record) => (
                <p >{record?.Ticket?.TicketCategory?.name}</p>
            ),
        },
        {
            title: 'DATE OPENED',
            dataIndex: 'dateopened',
            key: 'dateopened',
            width: '150px',

            render: (text, record) => (
                <p style={{ width: '140px' }}>{moment(record?.createdAt).format('MM-DD-YYYY HH:mm')}</p>
            ),
        },
        {
            title: 'DAYS OPEN',
            dataIndex: 'daysopen',
            key: 'daysopen',
            width:'110px',
            render: (text, record) => (
                <p >{record?.DaysOpen}</p>
            ),
        },
        {
            title: 'STATUS',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => (
                <p >{record?.Status}</p>
            ),
        },
        {
            title: 'ASSIGNED TO',
            dataIndex: 'assignedto',
            key: 'assignedto',
            width:'200px',
            render: (text, record) => (
                <p  style={{ width: '200px'}}>{contractormap(record?.Assignedto) || contractormap(record?.AssignedtoContractor) || 'N/A'}</p>
            ),
        },

    ];



    useEffect(() => {
        if (visible) {
            fetchData();
        }
    }, [visible]);
    return (
        <div className='asdsadas'>

            <Modal
                title={<span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Open Work Orders</span>}
                visible={visible}
                onOk={handleOk}
                onCancel={handleCancel}
                width={1130} 
            >
                <Table dataSource={tableData} columns={columns} />
            </Modal>
        </div>
    );
};

export default MyComponent;
